import HttpCliente from "../HttpCliente";

export const getRubros = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/Rubro/ObtenerRubros", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
}

export const postRubro = (token, rubro) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/Rubro/Crear", rubro, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const putRubro = (token, rubro) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/Rubro/EditarRubro", rubro, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        }
    }).then(response => {
        resolve(response.data);
        }).catch(error => {
        reject(error);
        });
    });
}

export const deleteRubro = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.delete(`/Rubro/Deshabilitar/${id}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
        resolve(response.data);
        }).catch(error => {
        reject(error);
        });
    });
}

export const getRubrosCliente = (token, idUsuario) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/Rubro/ObtenerRubrosCliente/${idUsuario}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
}

export const getRubroHabilitado = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/Rubro/ObtenerRubrosHabilitados", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
        }
    }).then(response => {
        resolve(response.data);
        }).catch(error => {
        reject(error);
        });
    });
}